export interface GupshupTemplateButton {
  type: 'COPY_CODE' | 'OTP' | 'PHONE_NUMBER' | 'QUICK_REPLY' | 'URL';
  text?: string; // Optional only for COPY_CODE type
  phone_number?: string; // Required for PHONE_NUMBER type
  url?: string; // Required for URL type
  example?: string[] | string;
  buttonValue?: string;
  suffix?: string;
  otp_type?: string; // Optionally for "Authentication" category
  'otp-type'?: string; // Optionally for "Authentication" category
  autofill_text?: string; // One-tap buttons only
  package_name?: string; // One-tap buttons only
  signature_hash?: string; // One-tap buttons only
}

export interface StrapiTemplate {
  buttons: GupshupTemplateButton[] | null;
  category: string;
  createdAt: string;
  gupshupTemplateId: string | null;
  mediaId: string | null;
  mediaUrl: string | null;
  name: string;
  reason: string | null;
  status: string;
  text: string | null;
  type: string;
  updatedAt: string;
}

export enum TemplateCategory {
  UTILITY = 'UTILITY',
  // AUTHENTICATION = 'AUTHENTICATION',
  MARKETING = 'MARKETING',
  TRANSACTIONAL = 'TRANSACTIONAL',
}

export enum TemplateType {
  TEXT = 'TEXT',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  DOCUMENT = 'DOCUMENT',
}

export type MediaTemplateType = Exclude<TemplateType, TemplateType.TEXT>;

export enum TemplateLanguageCode {
  es = 'es',
  en = 'en',
}

export enum TemplateReasonsRejections {
  ABUSIVE_CONTENT = 'ABUSIVE_CONTENT',
  INCORRECT_CATEGORY = 'INCORRECT_CATEGORY',
  SCAM = 'SCAM',
  INVALID_FORMAT = 'INVALID_FORMAT',
  NONE = 'NONE',
}

export type TemplateButtonInput =
  | { type: 'QUICK_REPLY'; text: string }
  | { type: 'URL'; text: string; url: string; example?: string[] }
  | { type: 'PHONE_NUMBER'; text: string; phoneNumber: string };

export type ButtonsKind = 'QUICK_REPLY' | 'CTA';

export interface CreateTemplateDTO {
  category: TemplateCategory;
  type: TemplateType;
  languageCode: TemplateLanguageCode;
  name: string;
  text: string;
  mediaId?: string | null;
  buttons?: TemplateButtonInput[];
}

export type TemplateResponseDto = StrapiTemplate;
